/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Filters from '../../../components/Filters';
import { ControlTable } from '../../../components/Table';
import useForm from '../../../hooks/useForm';
import { isEmpty } from '../../../utils/lodashExtend';
import TradeEtcInvoice from './TradeEtcInvoice';
import { dateToFormat, getDay } from "../../../utils/date";
import { clientPreview } from "../../../utils/client";
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import Icon from '../../../components/Icon';
import { preventEvent } from '../../../utils/element';
import { autoHyphen } from '../../../utils/replace';
import { findIndex, forEach, sortBy } from 'lodash';
import ToolTip from '../../../components/ToolTip/ToolTip';
import { transformComma } from '../../../utils/validator/comma';
import { deleteEtcInvoice, getEtcInvoiceList } from '../../../apis/invoices';
import { getParams } from '../../../utils/params';
import systemAlert from '../../../utils/systemAlert';
import TradeInvoice from '../Trade/TradeInvoice';


const SalesEtcInvoice = ({
  open,
  setOpen,
  permission,
  mode,
  setMode,
  type,
}) => {
  const history = useHistory();
  const [filters] = useState([
    { title: "조회기간 (작성일자)", key: "range.writeDate", type: "customdatepicker" },
    { title: "거래처명", key: 'search.byrCorpName' }
  ]);
  const [fields, setFields] = useState([]);
  const [rowData, setRowData] = useState({});

  // 거래명세서 발행
  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});

  const [sortFields, setSortFields] = useState([
    { key: 'createdTime', order: 'desc' },
    { key: 'writeDate', order: '' },
    { key: 'taxAmt', order: '' },
    { key: 'totalAmt', order: '' },
    { key: 'supplyAmt', order: '' },
  ]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    reSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setOrderBy
  } = useForm({
    search: {
      byrCorpName: ""
    },
    range: {
      writeDate: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date
    },
    order: [
      { createdTime: 'desc' }
    ],
    page: 0,
    limit: 10
  },);

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }

    setFields([
      { title: "작성일자", key: "writeDate", className: 'nowrap', type: 'date', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "등록일자", key: "createdTime", className: 'nowrap', type: 'date', sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: "상호", key: "byrCorpName",
        onValue: (value, field, data) => {
          return <p
            onClick={(e) => {
              preventEvent(e);
              data?.client && clientPreview(data.client.companyAccountIdx);
            }}

          >{value}</p>;
        }
      },
      { title: "대표자명", key: "byrRepName" },
      {
        title: "사업자번호",
        key: "byrBizNo",
        onValue: (value) => {
          return value ? autoHyphen("comNum", value) : "-";
        },
      },
      {
        // title: "대표품목",
        title: "품목",
        key: "invoiceItems[0].prodName",
        onValue: (value, field, form) => {
          let itemsLabels = '';
          let items = "";
          if (!isEmpty(form.invoiceItems)) {
            forEach(form.invoiceItems, (item) => {
              if (item.order <= 1) {
                items =
                  form.invoiceItems.length > 1
                    ? `${item.prodName} 외 ${form.invoiceItems.length - 1}건`
                    : item.prodName;
              }
              const unit = item.unit || '개';
              itemsLabels += `${item.prodName}: ${transformComma(item.unitCost)}원 x ${item.qty} ${unit} = ${transformComma(item.supplyCost + item.taxAmt)}원 (부가세포함) \n`;
            });
          }

          return <>{items}<ToolTip
            position="bottom"
            tooltiptext={itemsLabels}
          /></>;
        },
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        className: 'nowrap',
        onValue: (value) => {
          return transformComma(value);
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "세액",
        key: "taxAmt",
        className: 'nowrap',
        onValue: (value) => {
          return transformComma(value);
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "합계금액",
        key: "totalAmt",
        className: 'nowrap',
        onValue: (value) => {
          return transformComma(value);
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      }
    ]);
  }, [sortFields]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, [type]);

  const submit = (params) => {
    setIsLoading(true);
    getEtcInvoiceList(type, { ...getParams(params) })
      .then((res) => {
        const { count, rows, comment } = res.data;
        const transList = rows.map((etcInvoice) => ({
          ...etcInvoice,
          comments: comment.listByPost.find(c => c.postIdx === etcInvoice.idx) || {}
        }));

        setList(transList);
        setTotal(count);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  const handleOnRowClick = (data) => {
    setRowData(data);
    if (isEmpty(data.mappedTaxInvoices) && permission.level > 1) {
      setMode("modify");
    } else {
      setMode("detail");
    }
    setSelectedList([]);
    setOpen(true);
  };

  const getCheckboxDisabled = (data) => {
    let disabled = false;

    if (!isEmpty(selectedList)) {
      if (data.clientIdx !== selectedList[0].clientIdx) {
        disabled = true;
      }
    }

    return disabled;
  };

  const createInvoice = () => {

    setInvoiceOpen(true);
    const sortSelectedList = sortBy(selectedList, ["writeDate"]);
    const items = [];
    for (const obj of sortSelectedList) {
      for (const item of obj.etcInvoiceItems) {
        items.push({
          // date: item.trDate,
          trMonth: dateToFormat(item.trDate, "M"),
          trDate: dateToFormat(item.trDate, "D"),
          prodName: item.prodName,
          unit: item.unit,
          qty: item.qty,
          unitCost: transformComma(item.unitCost),
          supplyCost: transformComma(item.supplyCost),
          taxAmt: transformComma(item.taxAmt),
          remark: item.remark,
          prodIdx: item.prodIdx,
        });
      }
    };
    const invoice = {
      etcInvoiceIdx: sortSelectedList[0].idx,
      clientIdx: sortSelectedList[0]?.client?.companyAccountIdx,
      supByrType: sortSelectedList[0].supByrType,
      taxType: sortSelectedList[0].taxType,
      supBizCategory: sortSelectedList[0].supBizCategory,
      supBizItem: sortSelectedList[0].supBizItem,
      writeDate: sortSelectedList[0].writeDate,
      supBizNo: sortSelectedList[0].supBizNo,
      supBizSubNo: sortSelectedList[0].supBizSubNo,
      supCorpName: sortSelectedList[0].supCorpName,
      supRepName: sortSelectedList[0].supRepName,
      supAddress: sortSelectedList[0].supAddress,
      byrBizNo: sortSelectedList[0].byrBizNo,
      byrBizSubNo: sortSelectedList[0].byrBizSubNo,
      byrBizCategory: sortSelectedList[0].byrBizCategory,
      byrBizItem: sortSelectedList[0].byrBizItem,
      byrCorpName: sortSelectedList[0].byrCorpName,
      byrRepName: sortSelectedList[0].byrRepName,
      byrAddress: sortSelectedList[0].byrAddress,
      totalAmt: sortSelectedList[0].totalAmt,
      supplyAmt: sortSelectedList[0].supplyAmt,
      taxAmt: sortSelectedList[0].taxAmt,
      remark: sortSelectedList[0].remark,
      supEmail: sortSelectedList[0].supEmail,
      byrEmail1: sortSelectedList[0].byrEmail1,
      byrEmail2: sortSelectedList[0].byrEmail2,
      memo: sortSelectedList[0].memo,
      uploadFiles: sortSelectedList[0].uploadFiles,
      items
    };

    setInvoiceData(invoice);
  };

  const headerButtonConfig = [
    {
      label: '거래명세서 발행',
      color: 'line',
      action: () => createInvoice(),
      disabled: isEmpty(selectedList)
    },
  ];

  const rowBtnConfig = {
    title: '삭제',
    rowButtons: [
      {
        type: "delete",
        className: "ml-4",
        action: (data) => {

          let message = `해당 ${type === "quotation" ? "견적서" : "발주서"}를 삭제하시겠습니까?`;
          systemAlert(message, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '확인',
                onClick: () => {
                  deleteEtcInvoice(data.idx).then(() => {
                    submit(form);
                    setSelectedList([]);
                  });
                }
              }
            ]
          });
        },
      },
    ],
  };

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };


  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />

      <ControlTable
        isControl={permission.level > 1}
        isHideAllCheck
        isLoading={isLoading}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        list={list}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        selectedList={selectedList}
        setSelected={setSelectedList}
        onSelect={handleOnRowClick}
        checkboxDisabled={getCheckboxDisabled}
        buttons={permission.level > 1 ? headerButtonConfig : []}
        submit={handleSubmit}
        rowBtn={permission.level > 1 ? rowBtnConfig : {}}
      />

      <TradeEtcInvoice
        open={open}
        setOpen={setOpen}
        supByrType={type === "quotation" ? "sales" : "purchase"}
        formType={mode}
        setFormType={setMode}
        list={rowData}
        setList={setRowData}
        submit={reSubmit}
        permission={permission}
        type={type}
      />

      {invoiceOpen && !isEmpty(invoiceData) && (
        <TradeInvoice
          open={invoiceOpen}
          setOpen={setInvoiceOpen}
          supByrType={type === "quotation" ? "sales" : "purchase"}
          list={[invoiceData]}
          formType={"create"}
          submit={reSubmit}
          permission={permission}
        />
      )}
    </>
  );
};

export default SalesEtcInvoice;